export default __webpack_public_path__ + "static/media/ConnectHealthPro.1846ef21.png";